export default __webpack_public_path__ + "0cb76ca1c980f3eaa0041ee7990fc7f7.png";